import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { ReviewEventType, useBatchSubmitReviewEventMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSubmitReviewEventDialog',
  props: {
    value: {
      type: Boolean
    },
    reviewRequestId: null,
    ventures: null
  },
  emits: ["input", "submitted"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var eventType = ref('APPROVED');
    var comment = ref('');
    var showCommentValidation = ref(false);
    var showSelectionValidation = ref(false);
    var selectedVentureIds = ref([]);
    var submitting = ref(false);
    var _useBatchSubmitReview = useBatchSubmitReviewEventMutation({
        refetchQueries: ['listReviewRequests', 'getReviewRequest', 'listReviewEvents']
      }),
      batchSubmitReviewEvent = _useBatchSubmitReview.mutate;
    var ventureRows = computed(function () {
      return props.ventures;
    });
    var allVentureIds = computed(function () {
      return ventureRows.value.map(function (venture) {
        return venture.ventureId;
      });
    });
    var allVenturesSelected = computed(function () {
      return allVentureIds.value.length > 0 && allVentureIds.value.every(function (id) {
        return selectedVentureIds.value.includes(id);
      });
    });
    var someVenturesSelected = computed(function () {
      return selectedVentureIds.value.length > 0;
    });
    var commentErrors = computed(function () {
      return showCommentValidation.value && eventType.value === 'EDITS_REQUESTED' && !comment.value.trim() ? [String(proxy.$t('commentRequired'))] : [];
    });
    var selectionErrors = computed(function () {
      return showSelectionValidation.value && selectedVentureIds.value.length === 0 ? [String(proxy.$t('selectAtLeastOne'))] : [];
    });
    var resetForm = function resetForm() {
      eventType.value = 'APPROVED';
      comment.value = '';
      showCommentValidation.value = false;
      showSelectionValidation.value = false;
      selectedVentureIds.value = props.ventures.filter(function (venture) {
        return venture.status !== 'APPROVED';
      }).map(function (venture) {
        return venture.ventureId;
      });
    };
    watch(function () {
      return props.value;
    }, function (open) {
      if (open) {
        resetForm();
      }
    });
    watch(ventureRows, function (rows) {
      if (!props.value) {
        return;
      }
      selectedVentureIds.value = rows.filter(function (venture) {
        return venture.status !== 'APPROVED';
      }).map(function (venture) {
        return venture.ventureId;
      });
    }, {
      immediate: true
    });
    var toggleVentureSelection = function toggleVentureSelection(ventureId, selected) {
      if (selected) {
        if (!selectedVentureIds.value.includes(ventureId)) {
          selectedVentureIds.value = [].concat(_toConsumableArray(selectedVentureIds.value), [ventureId]);
        }
        return;
      }
      selectedVentureIds.value = selectedVentureIds.value.filter(function (id) {
        return id !== ventureId;
      });
    };
    var toggleSelectAll = function toggleSelectAll(selected) {
      selectedVentureIds.value = selected ? _toConsumableArray(allVentureIds.value) : [];
    };
    var submit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _result$data, _payload$successCount, _payload$failureCount, result, payload, successCount, failureCount;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showSelectionValidation.value = true;
              if (selectedVentureIds.value.length) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (!(eventType.value === 'EDITS_REQUESTED' && !comment.value.trim())) {
                _context.next = 6;
                break;
              }
              showCommentValidation.value = true;
              return _context.abrupt("return");
            case 6:
              submitting.value = true;
              _context.prev = 7;
              _context.next = 10;
              return batchSubmitReviewEvent({
                input: {
                  reviewRequestId: props.reviewRequestId,
                  ventureIds: selectedVentureIds.value,
                  eventType: eventType.value === 'APPROVED' ? ReviewEventType.Approved : ReviewEventType.EditsRequested,
                  comment: comment.value.trim()
                }
              });
            case 10:
              result = _context.sent;
              payload = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.batchSubmitReviewEvent;
              successCount = (_payload$successCount = payload === null || payload === void 0 ? void 0 : payload.successCount) !== null && _payload$successCount !== void 0 ? _payload$successCount : 0;
              failureCount = (_payload$failureCount = payload === null || payload === void 0 ? void 0 : payload.failureCount) !== null && _payload$failureCount !== void 0 ? _payload$failureCount : 0;
              window.$nuxt.$emit('userMsg', {
                color: failureCount > 0 ? 'warning' : 'green',
                message: payload ? "".concat(proxy.$t('batchSuccess'), " ").concat(proxy.$t('successSummary', {
                  success: successCount,
                  failed: failureCount
                })) : proxy.$t('batchSuccess')
              });
              emit('submitted');
              emit('input', false);
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](7);
              window.$nuxt.$emit('userError', {
                message: (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || String(_context.t0)
              });
            case 22:
              _context.prev = 22;
              submitting.value = false;
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 19, 22, 25]]);
      }));
      return function submit() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      eventType: eventType,
      comment: comment,
      showCommentValidation: showCommentValidation,
      showSelectionValidation: showSelectionValidation,
      selectedVentureIds: selectedVentureIds,
      submitting: submitting,
      batchSubmitReviewEvent: batchSubmitReviewEvent,
      ventureRows: ventureRows,
      allVentureIds: allVentureIds,
      allVenturesSelected: allVenturesSelected,
      someVenturesSelected: someVenturesSelected,
      commentErrors: commentErrors,
      selectionErrors: selectionErrors,
      resetForm: resetForm,
      toggleVentureSelection: toggleVentureSelection,
      toggleSelectAll: toggleSelectAll,
      submit: submit
    };
  }
});